// @flow

import type { FirebaseInteraction, Poll, Interaction } from '../../../types'

export function extractActivePolls (interactions: Interaction): Array<FirebaseInteraction> {
  return (interactions.list || [])
    .reduce((acc, pollId) => {
      // Need to this because flow complains that it does not support "non-string" literals as keys
      const interaction = interactions[`${pollId}`]
      if (interaction.status === 'ACTIVE') {
        interaction.id = pollId
        acc.push(interaction)
      }
      return acc
    }, [])
}

export function preparePoll (poll: FirebaseInteraction): Poll {
  return {
    id: poll.id,
    title: poll.title,
    alternatives: poll.alternatives
  }
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/helpers/pollUtils.js